import { gql } from "@apollo/client";

export const GET_LIST_RESERVATION = gql`
  query GetReservationList(
    $paginationParams: BaseCollection!
    $establishmentIds: [String!]
    $tripPublicationId: String
    $ownerId: String
    $search: String
    $status: TripReservationStatusEnum
  ) {
    QR_LIST_TRIP_RESERVATION(
      paginationParams: $paginationParams
      establishmentIds: $establishmentIds
      tripPublicationId: $tripPublicationId
      ownerId: $ownerId
      search: $search
      status: $status
    ) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        totalElements
        totalPages
        currentPage
        content {
          id
          status
          tripDate {
            startDate
            endDate
          }
          tripPublicationResume {
            trip {
              title
              reference
              establishment {
                id
                company {
                  legalName
                }
              }
            }
          }
        }
      }
    }
  }
`;
